var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "unitsManager h-full box-border text-left overflow-hidden"
  }, [_c('main', {
    staticClass: "bg-[#fff] rounded-[8px] shadow-[0_2px_8px_rgba(0,0,0,0.1)] overflow-hidden h-full flex flex-col p-4 flex-col"
  }, [_c('div', {
    staticClass: "unitNames pb-4"
  }, [_vm._v(_vm._s(_vm.unitInfo))]), _vm.showDetail ? _c('div', {
    staticClass: "unitTable box-border flex-1 min-h-0 flex h-full"
  }, [_c('div', {
    staticClass: "flex-1 w-full"
  }, [_c('div', {
    staticClass: "gap-2 flex py-2 items-center"
  }, [_c('Input', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "placeholder": $t("hjdfxsf", "输入单位代码，单位名称查找单位")
    },
    model: {
      value: _vm.search.keywords,
      callback: function ($$v) {
        _vm.$set(_vm.search, "keywords", $$v);
      },
      expression: "search.keywords"
    }
  }), _c('Select', {
    staticClass: "unit-type-select",
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "max-tag-count": 2,
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": $t("un78hr7", "请选择单位类型")
    },
    model: {
      value: _vm.search.type,
      callback: function ($$v) {
        _vm.$set(_vm.search, "type", $$v);
      },
      expression: "search.type"
    }
  }, _vm._l(_vm.unitTypeList, function (item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(" " + _vm._s(item.value) + " ")]);
  }), 1)], 1), _c('Table', {
    staticClass: "flex-1 min-w-0 max-w-full overflow-hidden",
    attrs: {
      "row-key": "code",
      "columns": _vm.columns16,
      "data": _vm.filterUnitList,
      "height": _vm.height
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function ({
        row,
        index
      }) {
        return [_c('i', {
          staticClass: "text-[18px] iconfont icon-a-edit-12x cursor-pointer",
          on: {
            "click": function ($event) {
              return _vm.editUnit(row, index);
            }
          }
        })];
      }
    }], null, false, 2352496473)
  })], 1), _c('Drawer', {
    attrs: {
      "width": 60,
      "title": $t("5rrrwf6", "编辑单位信息")
    },
    model: {
      value: _vm.enterPriseVisible,
      callback: function ($$v) {
        _vm.enterPriseVisible = $$v;
      },
      expression: "enterPriseVisible"
    }
  }, [_c('Enterprise', {
    ref: "EnterpriseRef",
    on: {
      "update": _vm.getUnitTree
    }
  })], 1)], 1) : _c('div', {
    staticClass: "unitTable flex-1 min-h-0 flex h-full overflow-hidden"
  }, [_c('div', {
    staticClass: "flex-1 min-h-0 overflow-hidden"
  }, [_c('Enterprise', {
    ref: "EnterpriseRef",
    on: {
      "update": _vm.getUnitTree
    }
  })], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };